import React from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import './PageHeader.css';


function PageHeader({title, title2, subTitle1, subTitle2, subTitle3}: any) {

  const navigate = useNavigate();

  return (
    <h4 className={`col-12 pageHeader`}>
      <div className='d-flex align-items-center'>
        <div className='col-sm-6 col-12 d-flex justify-content-start'>
          <div><img
            className='logoIcon'
            style={{"paddingRight": "30px", "cursor": "pointer"}}
            src="logo.png"
            // height='60'
            alt='Version 1.0.4.2'
            loading='lazy'
            onClick={() => {navigate("/")}}
          /></div>
          <div>{title}<br></br>{title2}</div>
        </div>
        <div className='col-sm-6 d-none d-sm-flex justify-content-end align-items-center p-1'>
          <div style={{"height": "fit-content","lineHeight": "24px"}}>
            <div className="d-flex justify-content-center" style={{"fontSize":"20px"}}>{subTitle1}</div>
            <div className="d-flex justify-content-center" style={{"fontSize":"14px"}}>{subTitle2}</div>
            <div className="d-flex justify-content-center" style={{"fontSize":"10px"}}>{subTitle3}</div>
          </div>
        </div>
      </div>
    </h4>
  );
}

export default PageHeader;